import { http } from '@/providers/apis/http';
import { registrySerializer } from '@/providers/serializers/registry/registry';
import { isEmptyValue } from '@/utils/utils';

export class RegistryAPI {

  private static INSTANCE = new RegistryAPI();

  private namespace = 'api/learning-registry/v1';

  static get instance() {
    return this.INSTANCE;
  }

  public fetchRegistryList() {
      const endpoint = `${window.location.origin}/stubs/registry.json`;
      const headers = http.getTokenHeaders();
      return http.get(endpoint, headers).then((response) => {
        return response.data;
      });
  }

  public fetchRegistryById(id: any) {
    const endpoint = `${window.location.origin}/stubs/registry.json`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data.filter((data: any) => data.id === id);
    });
  }

  public removeSelectedNavItem(navItem: any, isSuperUser: boolean) {
    const removingItems = ['/partner-registry'];

    if (navItem && !isSuperUser) {
      const mainList = [];
      const subList = [];
      for (const [index, value] of navItem.entries()) {
         if (removingItems.includes(value.path)) {
          mainList.push(index);
         }
         if (value.subMenu) {
           for (const [subIndex, subValue] of value.subMenu.entries()) {
            if (removingItems.includes(subValue.path)) {
              subList.push(subIndex);
             }
           }
           if (subList.length > 0) {
             for (const [subInd , subValues] of subList.entries()) {
              value.subMenu.splice(subList[subInd], 1);
             }
           }
         }
      }
      if (mainList.length > 0) {
        for (const [mainInd, mainValue] of mainList.entries()) {
          navItem.splice(mainList[mainInd], 1);
         }
      }

      return navItem;
    } else {
      return navItem;
    }
  }

  public fetchToolRegistryList(params: any , tenantID: any) {
    const endpoint = `${this.namespace}/tool/registry/list`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return registrySerializer.serializeToolRegistryList(response.data, tenantID);
    }).catch((error: any) => {
      return { message: 'error' };
    });
  }

  public fetchContentProviderList(params: any, tenantID: any) {
    const endpoint = `${this.namespace}/content/registry/list`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return registrySerializer.serializeContentProviderList(response.data, tenantID);
    }).catch((error: any) => {
      return { message: 'error' };
    });
  }

  public subscribeSelectedTool(dataTosubscribe: any) {
    const endpoint = `${this.namespace}/tool/subscribe`;
    const headers = http.getTokenHeaders();
    return http.post(endpoint, headers, dataTosubscribe).then((response) => {
      return response;
      // return response.data.filter((data: any) => data.id === id);
    });
  }

  public updateSubscribedToolStatus(dataTosubscribe: any) {
    const endpoint = `${this.namespace}/tool/subscribe/${dataTosubscribe.tool_provider_id}`;
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, dataTosubscribe).then((response) => {
      return response;
      // return response.data.filter((data: any) => data.id === id);
    });
  }

}

export const registryAPI = RegistryAPI.instance;
